"use client";

import { createContext, useContext, useState } from "react";
import RequestModal from "./RequestModal";

type Ctx = {
  open: () => void;
};

const ContactCtx = createContext<Ctx>({ open: () => {} });

export function useContactModal() {
  return useContext(ContactCtx);
}

export default function ContactProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [open, setOpen] = useState(false);
  return (
    <ContactCtx.Provider value={{ open: () => setOpen(true) }}>
      {children}
      <RequestModal open={open} onClose={() => setOpen(false)} />
    </ContactCtx.Provider>
  );
}
